import { render } from "./DocumentationView.vue?vue&type=template&id=670b8266"
import script from "./DocumentationView.vue?vue&type=script&lang=js"
export * from "./DocumentationView.vue?vue&type=script&lang=js"

import "./DocumentationView.vue?vue&type=style&index=0&id=670b8266&lang=scss"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__